import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { NAV_LINKS, PRODUCT_LINKS, PLATFORM_LINKS } from "../../data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-navy-950">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2 max-w-sm">
            <Logo size={36} />
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              An independent, model-agnostic control layer for AI and human
              conversations. norse3 applies your policies in real time,
              intervenes when required and creates a reviewable audit trail for
              risk, security and compliance teams.
            </p>
            <p className="mt-4 text-xs text-muted-foreground/70">
              norse3 is not an AI agent, chatbot, underlying model, compliance
              replacement or guarantee.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground">Products</h4>
            <ul className="mt-4 space-y-2.5">
              {PRODUCT_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground">Explore</h4>
            <ul className="mt-4 space-y-2.5">
              {[...PLATFORM_LINKS, ...NAV_LINKS].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground">Get in touch</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/book-a-demo" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Book a walkthrough
                </Link>
              </li>
              <li>
                <a href="mailto:info@norse3.com" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  info@norse3.com
                </a>
              </li>
              <li>
                <Link to="/investor" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Investor access
                </Link>
              </li>
              <li>
                <Link to="/trust-centre" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Trust Centre
                </Link>
              </li>
              <li className="text-sm text-muted-foreground leading-relaxed" data-testid="footer-address">
                <address className="not-italic">Norse3 Limited<br />11 Dominion Way, Worthing<br />United Kingdom, BN14 8AQ</address>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground/70 max-w-xl" data-testid="footer-legal">
            © {year} Norse3 Limited. Registered in England and Wales, company number 16812462.
            Registered office: 11 Dominion Way, Worthing, United Kingdom, BN14 8AQ. Screenshots and figures are
            illustrative unless verified.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-muted-foreground/70">
            <Link to="/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms-link">Terms of Use</Link>
            <button type="button" onClick={() => window.dispatchEvent(new Event("norse3:open-cookie-settings"))} className="hover:text-foreground transition-colors" data-testid="footer-cookie-settings">Cookie settings</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
